import Card from 'components/ui/Card';
import Container from 'components/ui/Container';
import { Separator } from 'components/ui/Separator';
import Switch from 'components/ui/Switch';
import { t } from 'services/i18n.service';
import { LogQuantityQuestion } from 'interfaces';
import LogType from './LogType';
import LogQuestions from './LogQuestions';

interface LogDataProps {
  logQuantity: boolean;
  onLogQuantityChange: (value: boolean) => void;
  logQuestions: LogQuantityQuestion[];
  onLogQuestionsChange: (questions: LogQuantityQuestion[]) => void;
  logSummaryType: string;
  onLogSummaryTypeChange: (value: string) => void;
  choiceId?: string;
}

const LogData: React.FC<LogDataProps> = ({
  logQuantity,
  onLogQuantityChange,
  logQuestions,
  onLogQuestionsChange,
  logSummaryType,
  onLogSummaryTypeChange,
  choiceId
}) => {
  return (
    <div className='w-full flex flex-col ~gap-6/8'>
      {/* Enable Data Logging Section */}
      <Card className='flex flex-col ~gap-2/3'>
        <div className='flex items-start justify-between ~gap-4/6'>
          <div className='flex-1 flex flex-col ~gap-1/2'>
            <div className='flex items-center ~gap-2/3'>
              <Switch checked={logQuantity} onChange={onLogQuantityChange} />
              <span className='~text-xs/base'>
                {t('tabs_revamp.log_data_tab.enable_data_logging')}
              </span>
            </div>
            <p className='~text-xs/sm text-gray-600 dark:text-gray-400 ~ml-0/0'>
              {t('tabs_revamp.log_data_tab.enable_data_logging_description')}
            </p>
          </div>
        </div>

        <Separator />
        {/* Wrap sections in relative container for overlay */}
        <div className='relative'>
          {/* Overlay when data logging is disabled */}
          {!logQuantity && (
            <div className='absolute inset-0 z-10 bg-white/5 dark:bg-gray-900/80 backdrop-blur-sm rounded-lg' />
          )}

          <Container
            className={`flex flex-col ~gap-4/6 ${!logQuantity ? 'pointer-events-none opacity-50' : ''}`}>
            <LogType
              logSummaryType={logSummaryType}
              onLogSummaryTypeChange={onLogSummaryTypeChange}
              choiceId={choiceId}
            />
            <Separator />

            <LogQuestions
              logQuestions={logQuestions}
              onLogQuestionsChange={onLogQuestionsChange}
              choiceId={choiceId}
            />
          </Container>
        </div>
      </Card>
    </div>
  );
};

export default LogData;
